import { isTruthy } from '@ardoq/common-helpers';
import { componentInterface } from '@ardoq/component-interface';
import { referenceInterface } from '@ardoq/reference-interface';
import { fieldInterface } from '@ardoq/field-interface';
import { workspaceInterface } from '@ardoq/workspace-interface';
import { ArdoqId } from '@ardoq/api-types';
import { fieldOperations } from '@ardoq/core';
import { URLFieldValue } from '../types';

const impureGetComponentTypeFields = (
  modelId: ArdoqId,
  workspaceModelId: ArdoqId
) => {
  const typeId = componentInterface.get(modelId)?.typeId ?? null;
  return typeId === null
    ? []
    : fieldInterface.getFieldsByComponentType(typeId, workspaceModelId);
};

const impureGetReferenceTypeFieldIds = (
  modelId: ArdoqId,
  workspaceModelId: ArdoqId
) => {
  const typeId = referenceInterface.get(modelId)?.type ?? null;
  return typeId === null
    ? []
    : fieldInterface.getFieldsByReferenceType(typeId, workspaceModelId);
};

const impureGetUrlFieldValues = (
  isComponent: boolean,
  modelId: ArdoqId
): URLFieldValue[] | null => {
  const workspaceId = isComponent
    ? componentInterface.getWorkspaceId(modelId)
    : (referenceInterface.get(modelId)?.rootWorkspace ?? null);

  if (!workspaceId) return null;

  const workspaceModelId = workspaceInterface.getWorkspaceModelId(workspaceId);
  if (workspaceModelId === null) return null;

  const getTypeFields = isComponent
    ? impureGetComponentTypeFields
    : impureGetReferenceTypeFieldIds;
  const getFieldValue = isComponent
    ? (id: ArdoqId, fieldName: string) =>
        componentInterface.get(id)?.[fieldName] ?? null
    : (id: ArdoqId, fieldName: string) =>
        referenceInterface.get(id)?.[fieldName] ?? null;

  const urlFieldValues = getTypeFields(modelId, workspaceModelId)
    .filter(fieldOperations.isURLField)
    .map(field => {
      const url = getFieldValue(modelId, field.name);
      return url && typeof url === 'string'
        ? { label: field.label, url }
        : null;
    })
    .filter(isTruthy);

  return urlFieldValues.length > 0 ? urlFieldValues : null;
};
export { impureGetUrlFieldValues };
